import { parseJwt } from './Utils';

import fetch from 'node-fetch';
import https from 'https';

/**
 * Thrown by `query()` when the server responds with a non-2xx status (or the
 * fetch itself fails) and the caller did NOT opt into `full_response`. Callers
 * that pass `full_response: true` continue to receive the raw response object
 * and are expected to inspect `.status` themselves.
 *
 * Surface fields:
 *   - status:     HTTP status code, or 0 for network/transport errors
 *   - statusText: HTTP status text or the underlying error message
 *   - url, method: the request that failed
 *   - body:       parsed JSON body if the server returned one (often the
 *                 server's structured error envelope)
 */
class ApiError extends Error {
    constructor({ status, statusText, url, method, body, cause }) {
        const label = `${method || 'REQUEST'} ${url || ''}`.trim();
        super(`${label} failed: ${status}${statusText ? ' ' + statusText : ''}`);
        this.name = 'ApiError';
        this.status = status;
        this.statusText = statusText;
        this.url = url;
        this.method = method;
        this.body = body;
        if (cause) this.cause = cause;
    }
}



const httpsAgent = new https.Agent({
    rejectUnauthorized: false,
});


// endpoint: 'https://localhost/api',
// function parseJwt (token) {
//     var base64Url = token.split('.')[1];
//     var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//     var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
//         return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
//     }).join(''));

//     return JSON.parse(jsonPayload);
// }

const Endpoints = {};
// const Endpoints = (process.env.NODE_ENV ===  "development") ?
// {"gwapi" :{ name: 'gwapi',
//     endpoint: 'http://localhost:8080/api',
//     service: 'c2-manager'
//     }} :
// {"gwapi" : {
//     name: 'gwapi',
//     endpoint: '/api',
//     service: 'c2-manager'
//     }}


const configure = (config) => {
    // console.log('configure',config)
    for (let endpoint of config.endpoints) {
        Endpoints[endpoint.name] = endpoint;
    }
}

const setJwtToken = (token) => {
    for (let endpoint of Object.keys(Endpoints)) {
        // console.log('endpoint',endpoint, 'token',token)
        Endpoints[endpoint].jwtToken = token;
        // console.log('Endpoints['+endpoint+']',Endpoints[endpoint])
    }
}


const get = (endpoint, path, params,  full_response) => {
    return query(endpoint, path, null, 'GET',params,full_response)
}

const put = (endpoint, path, body, full_response) => {
    return query(endpoint, path, body, 'PUT', null, full_response)
 }

const patch = (endpoint, path, body) => {
    return query(endpoint, path, body, 'PATCH')
 }

const post = (endpoint, path, body,  full_response) => {
    return query(endpoint, path, body, 'POST',null, full_response)
 }

const del = (endpoint, path, body) => {
    return query(endpoint, path, body, 'DELETE')
 }

 

const query = async (endpoint,path, body, method, params, full_response) => {
    // console.log('URL',endpoint,Endpoints[endpoint]);
    // Join base + path without producing a double slash when the configured endpoint
    // carries a trailing slash (e.g. MANAGE_API = ".../api/manager/"). A "//" in the path
    // is not normalized by every proxy and yields a 404 with an empty body, which surfaces
    // in the UI as "Unexpected end of JSON input".
    const base = (Endpoints[endpoint].endpoint || '').replace(/\/$/, '');
    let url = base + path;
    // Only GET (and similar) pass params; append query string so backend receives them (fetch does not use config.qs)
    const rawQs = params && (params.queryStringParameters || params);
    if (rawQs && typeof rawQs === 'object') {
        const qs = Object.fromEntries(
            Object.entries(rawQs).filter(([, v]) => v != null)
        );
        if (Object.keys(qs).length > 0) {
            const searchParams = new URLSearchParams(qs);
            url = url + (url.includes('?') ? '&' : '?') + searchParams.toString();
        }
    }

    let headers = {    
        'Content-type': 'application/json',
    }

    const config = {
        method: method
     };

    //  if (endpoint !== 'gwapi') {
       config.headers = headers;
    //  }
    //  else{
    //     config.headers = {};
    //  }

     let jwtToken = Endpoints[endpoint].jwtToken;
     if (jwtToken) {
        //  console.log('AUTH TOKEN: ', jwtToken);
        config.headers['Authorization'] = 'Bearer ' + jwtToken
        const decoded = parseJwt(jwtToken);
        const exp = decoded.exp * 1000;
        const currentTime = Date.now();

        // Refresh page to force user to log back in if JWT expired
        if (currentTime > exp) window.location.reload()
    }

    // sometimes the body is already set when passe in as well as the params so we need to check for that
    if (body) {
        if (body instanceof FormData) {
            config.body = body;
            delete config.headers['Content-type'];
        } else if (body.body instanceof FormData) {
            config.body = body.body;
            delete config.headers['Content-type'];
        } else if (body.body) {
            config.body = JSON.stringify(body.body)
        } else if (body) {
            config.body = JSON.stringify(body)
        }
    }

    if (params) {
        if (params.queryStringParameters) {
            config.qs = params.queryStringParameters;
            config.queryStringParameters = params.queryStringParameters;
        }
        else if(params){
            config.qs = params;
            config.queryStringParameters = params;
        }
    }

     
    let response;

    config.agent = httpsAgent;

    try {
        response = await fetch(url, config)
    }
    catch(error)
    {
        // Ignore SSL certificate errors for specific endpoints
        if (error.message && error.message.includes('ERR_CERT_AUTHORITY_INVALID')) {
            // Return a mock response to prevent the error from propagating
            return full_response ? { status: 200, data: null } : null;
        }
        console.log('c2api',error);
        if (full_response) {
            // Preserve the legacy "always return a response-shaped object" contract
            // for callers that explicitly inspect `.status`.
            return { status: 0, statusText: error?.message || 'Network error', data: null, ok: false };
        }
        throw new ApiError({
            status: 0,
            statusText: error?.message || 'Network error',
            url,
            method,
            body: null,
            cause: error,
        });
    }


    let results;
    if (response && response.status) {
        try {
            const raw = await response.text();
            if (raw) {
                try {
                    results = JSON.parse(raw);
                } catch (jsonError) {
                    // Non-JSON body — e.g. the plain-text 400 messages from the
                    // email-domain policy checks on /users. Keep the raw text so
                    // ApiError.body carries it (getErrorMessage renders string
                    // bodies) instead of silently dropping the server's reason.
                    console.log('Non-JSON response body for:', url);
                    results = raw;
                }
            } else {
                results = null;
            }
        } catch (readError) {
            console.log('Body read error for:', url, readError);
            results = null;
        }
    }



    if (full_response) {
        response.data = results;
        return response;
    }

    // Non-2xx responses used to be returned as if they were valid data, which
    // let mutations silently "succeed" in the UI (e.g. saving an edit against
    // a 404 endpoint). Surface them as ApiError so callers can react.
    if (!response || !response.status || response.status >= 400) {
        throw new ApiError({
            status: response ? response.status : 0,
            statusText: response ? response.statusText : 'No response',
            url,
            method,
            body: results,
        });
    }

    return results;

}


export { configure, get, put, post, patch, del, Endpoints, setJwtToken, ApiError }